import React, { useState, useEffect } from 'react';
import TR from './../../Trans';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

function CopyPlayList(props) {

  let [playListName, setPlayListName] = useState("");

  useEffect(() => { 
    setPlayListName(props.playListName+" ("+TR.cm_copy_noun+")");
  }, [props.open])

  const handleKeyDown = (event) => {
if (event.key === 'Enter') {
      props.onPlayListCopy(playListName);
    }
  };

  return (
    <BDialog openToLeft={props.openToLeft} disableRestoreFocus open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose}>
      <DialogTitle>{TR.cm_copy_playlist}</DialogTitle>
      <DialogContent>
        <InputLabel>{TR.cm_name}</InputLabel>
        <TextField
          autoFocus
          margin="dense"
          type="text"
          fullWidth
          defaultValue={props.playListName+" ("+TR.cm_copy_noun+")"}
          onChange={(e) => setPlayListName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          <Button
            color="success"
            className="muvika-dialog-action-right"
            onClick={() => props.onPlayListCopy(playListName)}>{TR.cm_save}</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default CopyPlayList;